import { render, staticRenderFns } from "./BaseImageVideo.vue?vue&type=template&id=5dce0aeb"
import script from "./BaseImageVideo.vue?vue&type=script&lang=ts"
export * from "./BaseImageVideo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports